<div class="section-column top-bottom-margin">
  <div [ngSwitch]="type" class="section-field inner-section-column">
    <label *ngSwitchCase="uiCollectionTypes.PowerInverter" class="ui-g-12 font-bold zero-padding">
      {{ 'grid-comp.power-inverter-data' | translate }} {{ index + 1 }}
    </label>
    <label *ngSwitchCase="uiCollectionTypes.Generator" class="ui-g-12 font-bold">
      {{ 'grid-comp.generator-data' | translate }} {{ index + 1 }}
    </label>
    <label *ngSwitchCase="uiCollectionTypes.PowerConverter" class="ui-g-12 font-bold">
      {{ 'grid-comp.converter-data' | translate }} {{ index + 1 }}
    </label>
  </div>
  <div *ngIf="type == uiCollectionTypes.PowerInverter" class="section-field">
    <label class="ui-g-5 required">
      {{ 'grid-comp.zerez-id' | translate }}
    </label>
    <p-inputMask
      type="text"
      [(ngModel)]="energyUnit.zerez_id"
      name="{{ type }}zerez_id{{ index }}"
      #{{type}}zerez_id{{index}}="ngModel"
      required
      [disabled]="isDisabled"
      [autoClear]="false"
      [mask]="zerezIdMask.mask"
      [characterPattern]="zerezIdMask.charPattern"></p-inputMask>
    <button
      *ngIf="!isDisabled"
      pButton
      type="button"
      style="margin-left: 1rem"
      [label]="isLoading ? ('technical-data.validating' | translate) : ('technical-data.check-id' | translate)"
      [icon]="isLoading ? 'pi pi-spin pi-spinner' : ' '"
      [disabled]="isLoading"
      (click)="validateZerezId()"></button>
  </div>
  <div class="section-field">
    <label class="ui-g-5 required">
      {{ type == uiCollectionTypes.PowerInverter ? ('grid-comp.model' | translate) : ('grid-comp.manufacturer' | translate) }}
    </label>
    <input
      class="form-control"
      type="text"
      pInputText
      [(ngModel)]="energyUnit.manufacturer"
      name="{{ type }}Manufacturer{{ index }}"
      #{{type}}Manufacturer{{index}}="ngModel"
      required
      [disabled]="isDisabled"
      [readonly]="type == uiCollectionTypes.PowerInverter" />
  </div>
  <div class="section-field">
    <label class="ui-g-5 required">
      {{ 'grid-comp.number-identical-units' | translate }}
    </label>
    <p-inputNumber
      class="form-control"
      [(ngModel)]="energyUnit.identical_units"
      name="{{ type }}identical_units{{ index }}"
      #{{type}}identical_units{{index}}="ngModel"
      required
      (ngModelChange)="identicalUnitsChange()"
      [disabled]="isDisabled"></p-inputNumber>
  </div>
  <div class="section-field">
    <label class="ui-g-5 required">
      {{ 'grid-comp.type' | translate }}
    </label>
    <input
      class="form-control"
      type="text"
      pInputText
      [(ngModel)]="energyUnit.type"
      name="{{ type }}Type{{ index }}"
      #{{type}}Type{{index}}="ngModel"
      required
      [disabled]="isDisabled"
      [readonly]="type == uiCollectionTypes.PowerInverter" />
  </div>
  <div [ngSwitch]="type" class="section-field">
    <label *ngSwitchCase="uiCollectionTypes.PowerInverter" class="ui-g-5 required">
      {{ 'grid-comp.max-power-inverter-unit' | translate }}
    </label>
    <label *ngSwitchCase="uiCollectionTypes.Generator" class="ui-g-5 required">
      {{ 'grid-comp.max-power-generator' | translate }}
    </label>
    <label *ngSwitchCase="uiCollectionTypes.PowerConverter" class="ui-g-5 required">
      {{ 'grid-comp.converter-effective-power' | translate }}
    </label>
    <p-inputNumber
      class="form-control"
      [(ngModel)]="energyUnit.max_unit_power"
      name="{{ type }}max_unit_power{{ index }}"
      (keydown)="detectDecimalSeparator($event)"
      #{{type}}max_unit_power{{index}}="ngModel"
      mode="decimal"
      locale="de-DE"
      [minFractionDigits]="0"
      [maxFractionDigits]="3"
      required
      (ngModelChange)="maxPowerChange($event)"
      [disabled]="isDisabled || type == uiCollectionTypes.PowerInverter"></p-inputNumber>
    <label class="ml-2">kW</label>
  </div>
  <div *ngIf="type == uiCollectionTypes.PowerInverter" class="section-field">
    <label class="ui-g-5">
      {{ 'grid-comp.certificate-number' | translate }}
    </label>
    <input
      pInputText
      type="text"
      class="form-control"
      name="{{ type }}certificate_number{{ index }}"
      #{{type}}certificate_number{{index}}="ngModel"
      [readonly]="true"
      [disabled]="isDisabled"
      [(ngModel)]="energyUnit.certificate_number" />
  </div>
  <div *ngIf="type == uiCollectionTypes.PowerInverter" class="section-field">
    <label class="ui-g-5">
      {{ 'grid-comp.certificate-validity' | translate }}
    </label>
    <input
      pInputText
      type="text"
      class="form-control"
      name="{{ type }}certificate_validity{{ index }}"
      #{{type}}certificate_validity{{index}}="ngModel"
      [readonly]="true"
      [disabled]="isDisabled"
      [(ngModel)]="energyUnit.certificate_validity" />
    <input
      required
      hidden
      pInputText
      type="text"
      class="form-control required"
      name="{{ type }}certificate_is_valid_confirmed{{ index }}"
      #{{type}}certificate_is_valid_confirmed{{index}}="ngModel"
      [disabled]="isDisabled"
      [ngModel]="isValidityConfirmed" />
  </div>
  <div *ngIf="type == uiCollectionTypes.PowerInverter" class="section-field">
    <label class="ui-g-5">
      {{ 'grid-comp.certificate-status' | translate }}
    </label>
    <input
      pInputText
      type="text"
      class="form-control"
      name="{{ type }}certificate_status{{ index }}"
      #{{type}}certificate_status{{index}}="ngModel"
      [readonly]="true"
      [disabled]="isDisabled"
      [(ngModel)]="energyUnit.certificate_status" />
  </div>
  <div class="field-padding section-field" [ngSwitch]="type">
    <label *ngSwitchCase="uiCollectionTypes.Generator" class="ui-g-5 required">
      {{ 'grid-comp.generator-data-sheet' | translate }}
    </label>
    <label *ngSwitchCase="uiCollectionTypes.PowerConverter" class="ui-g-5 required">
      {{ 'grid-comp.converter-data-sheet' | translate }}
    </label>
    <app-file-upload
      *ngIf="type != uiCollectionTypes.PowerInverter"
      class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
      [fileData]="productDataSheet"
      [type]="documentTypes.EnergyUnitDataSheet"
      [isDetailsView]="isDetailsView && productDataSheet?.document_id"
      [isClearButtonDisabled]="isDisabled"
      [isUploadDisabled]="isDisabled"
      [isRequired]="!isDisabled"
      [inputName]="type + 'sub_product_data_sheet' + index"
      (clearFileEvent)="clearFile($event)"></app-file-upload>
  </div>
  <div [ngSwitch]="type" class="field-padding section-field" [class]="type === uiCollectionTypes.PowerConverter ? 'mt-3' : ''">
    <label *ngSwitchCase="uiCollectionTypes.Generator" class="ui-g-5 required">
      {{ 'grid-comp.generator-unit-certificate' | translate }}
    </label>
    <label *ngSwitchCase="uiCollectionTypes.PowerConverter" class="ui-g-5 required">
      {{ 'grid-comp.converter-unit-certificate' | translate }}
    </label>
    <app-file-upload
      *ngIf="type != uiCollectionTypes.PowerInverter"
      class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
      [fileData]="unitCertificate"
      [type]="documentTypes.UnitCertificate"
      [isDetailsView]="isDetailsView && unitCertificate?.document_id"
      [isClearButtonDisabled]="isDisabled"
      [isUploadDisabled]="isDisabled"
      [isRequired]="!isDisabled"
      [inputName]="type + 'unit_certificate' + index"
      (clearFileEvent)="clearFile($event)"></app-file-upload>
  </div>
  <div *ngIf="energyUnit.max_unit_power > 52" [ngSwitch]="type" class="field-padding section-field">
    <label *ngSwitchCase="uiCollectionTypes.PowerInverter" class="ui-g-5 required">
      {{ 'grid-comp.inverter-audit-report' | translate }}
    </label>
    <label *ngSwitchCase="uiCollectionTypes.Generator" class="ui-g-5 required">
      {{ 'grid-comp.generator-audit-report' | translate }}
    </label>
    <label *ngSwitchCase="uiCollectionTypes.PowerConverter" class="ui-g-5 required">
      {{ 'grid-comp.converter-audit-report' | translate }}
    </label>
    <app-file-upload
      class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
      [fileData]="auditReport"
      [type]="documentTypes.AuditReport"
      [isDetailsView]="isDetailsView && auditReport?.document_id"
      [isClearButtonDisabled]="isDisabled"
      [isUploadDisabled]="isDisabled"
      [isRequired]="!isDisabled"
      [inputName]="type + 'audit_report' + index"
      (clearFileEvent)="clearFile($event)"></app-file-upload>
  </div>

  <div class="btn-container">
    <div
      *ngIf="index > 0"
      (click)="removeElement(energyUnit)"
      class="pi pi-trash pointer-cursor right-aligned ui-g-2 remove-item-btn"
      [ngClass]="isDisabled ? 'disable-section' : ''"></div>
  </div>
</div>
